import { PropsWithChildren, useCallback, useMemo } from 'react'

import useStorefrontModeContext from '@src/quince-site-common/src/contexts/storefront-mode-context'

import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '../../config/statsig-experiments.config'

import { StatsigInitContext } from './statsig.context'

export function StatsigUserAgnosticProvider({ children }: PropsWithChildren) {
  const { isB2BMode } = useStorefrontModeContext()
  const getExperimentBucket = useCallback(
    (experimentKey: STATSIG_EXPERIMENTS | null) => {
      if (!experimentKey) return null
      const experiment = STATSIG_EXPERIMENTS_CONFIG[experimentKey]
      // Resolve B2B the way the user-aware provider does. This provider serves the requests with no
      // Statsig evaluation at all, which is exactly when B2B must not inherit a launched arm.
      if (isB2BMode) return experiment.defaultB2BBucket ?? experiment.defaultBucket
      return experiment.defaultBucket
    },
    [isB2BMode],
  )
  const value = useMemo(() => ({ init: false, getExperimentBucket }), [getExperimentBucket])
  return <StatsigInitContext.Provider value={value}>{children}</StatsigInitContext.Provider>
}
